import { createAction, props } from '@ngrx/store';
import { IBudgetState } from './budget.state';

export const initBudgetAction = createAction('[Budget Page] Budget page');

export const setBudgetAction = createAction(
  '[Budget Page] set data',
  props<IBudgetState>()
);
